import { Component, EventEmitter, Input, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import { BaseFormComponent } from '@shared/component/base/base-form.component';
import {
  SoleBusiness, SoleBusinessForm, SoleBusinessMessagesEnum, SoleBusinessService,
} from 'taxtank-core';
import { plainToClass } from 'class-transformer';

@Component({
  selector: 'app-sole-business-form',
  templateUrl: './sole-business-form.component.html',
  styleUrls: ['./sole-business-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SoleBusinessFormComponent extends BaseFormComponent {

  @Input() business: SoleBusiness;
  @Output() saved: EventEmitter<SoleBusiness> = new EventEmitter();
  form: SoleBusinessForm;

  private soleBusinessService = inject(SoleBusinessService);

  buildForm(): void {
    this.form = new SoleBusinessForm(this.business || plainToClass(SoleBusiness, {}));
  }

  save(business: SoleBusiness): void {
    if (business.id) {
      this.soleBusinessService.put(business).subscribe(() => {
        this.saved.emit(business);
        this.toastService.success(SoleBusinessMessagesEnum.UPDATED);
      });
    } else {
      this.soleBusinessService.post(business).subscribe(() => {
        this.saved.emit(business);
        this.toastService.success(SoleBusinessMessagesEnum.CREATED);
      });
    }
  }
}
